"use client";

import { useState, useRef } from "react";
import { usePathname } from "next/navigation";
import Image from "next/image";
import Link from "next/link";
import { Bars3Icon } from "@heroicons/react/24/outline";

export default function NavbarComponent() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const pathname = usePathname();


  function isActivePath(href) {
    return pathname === href;
  }

  return (
    <header className="bg-white">
      <nav aria-label="Global" className="mx-auto flex max-w-7xl items-center justify-between p-4 lg:px-8">
        <div className="flex-1 lg:flex-none">
          <Link href="/" className="flex items-center">
            <span className="sr-only">Water Doctor</span>
            <div className="w-[120px] h-[48px] relative">
              <Image
                src="/waterdoctor-logo.png"
                alt="Water Doctor Logo"
                fill
                sizes="120px"
                priority
                crossOrigin="anonymous"
                className="object-contain"
                style={{ objectFit: 'contain' }}
              />
            </div>
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="size-6" />
          </button>
        </div>
        <div className="hidden lg:flex lg:flex-1 lg:justify-center">
          <div className="flex gap-x-6">
            <Link
              href="/"
              className={`text-base font-semibold whitespace-nowrap ${isActivePath("/")
                ? "text-gray-900 underline underline-offset-8"
                : "text-gray-600 hover:text-gray-900"
                }`}
            >
              Home
            </Link>

            <Link
              href="https://shop.waterdoctor.ca/"
              className={`text-base font-semibold whitespace-nowrap ${isActivePath("/shop")
                ? "text-gray-900 underline underline-offset-8"
                : "text-gray-600 hover:text-gray-900"
                }`}
            >
              Shop
            </Link>

            <Link
              href="/showcase"
              className={`text-base font-semibold whitespace-nowrap ${isActivePath("/showcase")
                ? "text-gray-900 underline underline-offset-8"
                : "text-gray-600 hover:text-gray-900"
                }`}
            >
              Showcase
            </Link>

            <Link
              href="/blog"
              className={`text-base font-semibold whitespace-nowrap ${isActivePath("/blog")
                ? "text-gray-900 underline underline-offset-8"
                : "text-gray-600 hover:text-gray-900"
                }`}
            >
              Blog
            </Link>

            <Link
              href="/services"
              className={`text-base font-semibold whitespace-nowrap ${isActivePath("/services")
                ? "text-gray-900 underline underline-offset-8"
                : "text-gray-600 hover:text-gray-900"
                }`}
            >
              Services
            </Link>

            <Link
              href="/water-hardness"
              className={`text-base font-semibold whitespace-nowrap ${isActivePath("/water-hardness")
                ? "text-gray-900 underline underline-offset-8"
                : "text-gray-600 hover:text-gray-900"
                }`}
            >
              Water Hardness Check
            </Link>
          </div>
        </div>
        <div className="hidden lg:flex lg:flex-none">
          <Link
            href="/forms/home-assessment"
            className="inline-flex items-center justify-center rounded-md bg-sky-600 px-4 py-2 text-base font-semibold text-white shadow-xs hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition"
          >
            Book a Free Home Assessment
          </Link>
        </div>
      </nav>

      <div className={`lg:hidden ${mobileMenuOpen ? 'block' : 'hidden'}`}>
        <div className="px-4 py-2 border-t border-gray-200 bg-white shadow-lg">
          <div className="space-y-1 divide-y divide-gray-100">
            <div className="space-y-1 py-2">
              <Link
                href="/"
                className={`block px-3 py-2 text-base font-semibold rounded-md ${isActivePath("/")
                  ? "text-gray-900 bg-gray-50"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                href="https://shop.waterdoctor.ca/"
                className={`block px-3 py-2 text-base font-semibold rounded-md ${isActivePath("/shop")
                  ? "text-gray-900 bg-gray-50"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Shop
              </Link>
              <Link
                href="/showcase"
                className={`block px-3 py-2 text-base font-semibold rounded-md ${isActivePath("/showcase")
                  ? "text-gray-900 bg-gray-50"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Showcase
              </Link>
              <Link
                href="/blog"
                className={`block px-3 py-2 text-base font-semibold rounded-md ${isActivePath("/blog")
                  ? "text-gray-900 bg-gray-50"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Blog
              </Link>
              <Link
                href="/services"
                className={`block px-3 py-2 text-base font-semibold rounded-md ${isActivePath("/services")
                  ? "text-gray-900 bg-gray-50"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Services
              </Link>
              <Link
                href="/water-hardness"
                className={`block px-3 py-2 text-base font-semibold rounded-md ${isActivePath("/water-hardness")
                  ? "text-gray-900 bg-gray-50"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                  }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                Water Hardness
              </Link>
            </div>
            <div className="py-3">
              <Link
                href="/forms/home-assessment"
                className="block w-full text-center px-4 py-3 text-base font-semibold text-white bg-sky-600 rounded-md hover:bg-sky-500 shadow-sm transition"
                onClick={() => setMobileMenuOpen(false)}
              >
                Book a Free Home Assessment
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
